<template>
  <div>
  <!-- Header -->
    <div class="pageHeader page-header__flex">
      <div>Media Node Config</div>
      <div class="col text-right p-0">
        <div class="filterWrapper" style="margin-left: 0">
          <div class="filterText">Tenant :</div>
          <div class="dropdown col p-0">
            <model-select v-model="lastSelectedTenant" :options="tenants" name="tenantLableName" id="tenantLableId"
                          placeholder="Select Tenant" @input="tenantSelected" class="tenantList">
            </model-select>
          </div>
        </div>
      </div>
      <div class="col-2"><b-button variant="primary" @click="updatePexipConfig()">Refresh Pexip Config</b-button></div>
    </div>
    <!-- Body -->
    <div class="pageDataWrapper" v-if="lastSelectedTenant">
      <b-card class="card-container-panel" v-if="pexipMgtConfig.length > 0">
        <b-card-title>
          <div class="row">
            <div class="col-2">Management Config</div>
            <div class="col">
              <div @click.prevent="$refs['addNewManagementServer'].showModal = true">
                <img src="../../assets/images/add.svg" width="16" class="filterIcon" title="Add Location" />
              </div>
            </div>
          </div>
        </b-card-title>
        <div v-if="staticConfiguration" class="alert p-0"><b>Note: Tenant does not have Pexip configuration configured. Uses the default configuration from server config file.</b></div>
        <div class="contentHeader row m-0 align-items-center">
          <div class="col">
            Management Config
          </div>
        </div>
        <div v-if="pexipMgtConfig.length > 0" class="contentDataWrap">
          <div v-for="item in pexipMgtConfig" v-bind:key="item.key">
            <div class="contentDataWrapper actions contentActualDataWrapper row m-0">
              <div class="contentData row m-0 align-items-center col-12 p-0">
                <div class="col" style="padding-left: 30px">
                  <div class="row"><b>URL: </b><a :href="item.url" target="_blank" >{{item.url}}</a></div>
                  <div class="row"><b>Key: </b> {{item.key}}</div>
                  <div class="row"><b>Node Filter: </b> {{item.nodeFilter}}</div>
                  <div class="row"><b>Proxy Node Filter: </b> {{item.proxyNodeFilter}}</div>
                  <div class="row"><b>Pexip SDK: </b> {{item.pexipSDKVersion}}</div>
                  <div class="row"><b>Default: </b> {{item.default || false}}</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </b-card>
      <AddNewManagementServer ref="addNewManagementServer" :pexipMgtConfig="pexipMgtConfig" :staticConfiguration="staticConfiguration" :lastSelectedTenant="lastSelectedTenant" @managementServerSaved="managementServerInfoSaved" />
      <br>
      <b-card class="card-container-panel">
        <b-card-title>
          <div class="row">
            <div class="col-2">Device Config</div>
            <div class="col">
              <div @click.prevent="selectedDeviceFilter = null; $refs['addEditDeviceConfig'].showModal = true;">
                <img src="../../assets/images/add.svg" width="16" class="filterIcon" title="Add Location" />
              </div>
            </div>
            <div class="col">
              <div class="row">
                <div class="col">
                  <b-form-group label="" label-for="token" invalid-feedback="Please enter token.">
                    <b-form-input id="token" v-model="deviceFilterSearchString" placeholder="Enter atleast 3 chars for Search" @keyup="filterDeviceFilters" @keyup.enter="filterDeviceFilters"></b-form-input>
                  </b-form-group>
                </div>
                <div class="col-3"><b-button variant="primary" @click="clearSearch">Clear Search</b-button></div>
              </div>
            </div>
          </div>
        </b-card-title>
        <div class="contentHeader row m-0 align-items-center">
          <div class="col-7">Device filter</div>
          <div class="col-4">Config</div>
          <div class="col">Action</div>
        </div>
        <div v-if="pexipDeviceConfigWithFilter.length > 0" class="contentDataWrap">
          <div v-for="(item, index) in pexipDeviceConfigWithFilter" v-bind:key="item.filterName">
            <div class="contentDataWrapper actions contentActualDataWrapper row m-0" :class="{'row-light': index % 2}">
              <div class="contentData row m-0 align-items-center col-12 p-0">
                <div class="col-7" style="padding-left: 30px">
                  <div class="row">{{item.filterName}}</div>
                </div>
                <div class="col-4">
                  <div v-if="item.configs && item.configs.length > 0">
                    <div v-for="configItem in item.configs">
                      <div class="row"><b>IP CIDR:</b>{{configItem.ip_cidr}}</div>
                      <div class="row"><b>URL:</b><a :href="configItem.url" target="_blank" >{{configItem.url}}</a></div>
                      <div class="row" v-if="configItem.deviceMediaNode"><b>Device Media Node:</b>{{configItem.deviceMediaNode}}</div>
                      <div class="row" v-if="configItem.dashboardMediaNode"><b>Dashboard Media Node:</b>{{configItem.dashboardMediaNode}}</div>
                      <div class="row" v-if="configItem.mediaNode"><b>Media Node:</b>{{configItem.mediaNode}}</div><br>
                    </div>
                  </div>
                  <div v-if="item.config">
                    <div class="row"><b>URL:</b><a :href="item.config.url" target="_blank">{{item.config.url}}</a></div>
                    <div class="row" v-if="item.config.deviceMediaNode"><b>Device Media Node:</b>{{item.config.deviceMediaNode}}</div>
                    <div class="row" v-if="item.config.dashboardMediaNode"><b>Dashboard Media Node:</b>{{item.config.dashboardMediaNode}}</div><br>
                  </div>
                </div>
                <div class="col" @click.prevent="editDeviceFilters(item.filterKey)">
                  <img src="../../assets/images/edit.svg" width="16" style="margin-left:8px; cursor: pointer;" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </b-card>
      <AddEditDeviceConfig ref="addEditDeviceConfig" :pexipMgtConfig="pexipMgtConfig" :pexipDeviceConfig="pexipDeviceConfig"
                           :staticConfiguration="staticConfiguration" :lastSelectedTenant="lastSelectedTenant"
                           :defaultDeviceTypesForFilter="defaultDeviceTypesForFilter" :devices="devices"
                           @deviceFilterSaved="deviceFilterSaved" :locationList="locationList"
                            :selectedDeviceFilter="selectedDeviceFilter" />
    </div>
  </div>
</template>

<script>
import { ModelSelect } from "vue-search-select";
import Vue from "vue";
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
import VueToast from "vue-toast-notification";
import {dev} from "@fortawesome/vue-fontawesome/examples/vue-cli-webpack/config";

import AddNewManagementServer from "@/views/media-node-config/add-new-management-server.vue";
import AddEditDeviceConfig from "@/views/media-node-config/add-edit-device-config.vue";
Vue.use(Loading)
const DEFAULT_DEVICE_TYPES_IN_PEXIP_CONFIG = [
  {
    id: "AMS_R2W",
    type: "AMS R2W"
  },
  {
    id: "AMS_R2O",
    type: "AMS R2O"
  },
  {
    id: "AIM_H1",
    type: "AIM H1"
  },
  {
    id: "AIM_M2",
    type: "AIM M2"
  },
  {
    id: "AMS_T2v2",
    type: "AMS T2v2"
  },
  {
    id: "AMS_D2",
    type: "AMS D2"
  },
  {
    id: "ProCuity_3009",
    type: "ProCuity-3009"
  }
];
const DEFAULT_PEXIP_ATTRIBUTES_TO_IGNORE = ["_id", "key", "tenant", "management_servers", "staticConfiguration"];

Vue.use(VueToast);
Vue.use(Loading);
export default {
  components: {
    ModelSelect,
    AddNewManagementServer,
    AddEditDeviceConfig,
  },
  data() {
    return {
      lastSelectedTenant: "",
      tenants: [{text: "-SELECT ALL-", value: "*"}],
      tenantsList: [],
      locationList: [],
      pexipConfig: {},
      pexipMgtConfig: [],
      pexipDeviceConfig: [],
      pexipDeviceConfigWithFilter: [],
      devices: [],
      showModal: false,
      staticConfiguration: false,
      defaultDeviceTypesForFilter: DEFAULT_DEVICE_TYPES_IN_PEXIP_CONFIG,
      selectedDeviceFilter: {},
      deviceFilterSearchString: ""
    }
  },
  mounted() {
    // console.log('mounted', new Date().toISOString());
    this.fetchTenants();
  },
  async created() {

  },
  methods: {
    async fetchTenants() {
      const claims = await this.$auth.getIdTokenClaims();
      const id_token = claims.__raw;
      var tenants_list_request = new Request(
          config.TENET_SERVICE + "/tenants/?list=true",
          {
            method: "GET",
            mode: "cors",
            cache: "default",
            withCredentials: true,
            credentials: "include",
            headers: {
              Authorization: "Bearer " + id_token,
              "Content-Type": "application/json"
            }
          }
      );

      try {
        var tenants_list = await fetch(tenants_list_request);
        if (tenants_list.status === 503) {
          return this.fetchTenants();
        }
        var response = await tenants_list.json();
        this.tenants = response
            .map((t) => {
              return {
                text: t.text || t.value,
                id: t.value,
                value: t.value.toLowerCase()
              };
            })
            .sort((a, b) => {
              return a.text.localeCompare(b.text);
            });
        this.tenants.forEach((e) =>
            this.tenantsList.push({id: e.value, name: e.text})
        );
      } catch (error) {
        console.error(error);
      }
    },
    async tenantSelected() {

      let loader = Vue.$loading.show({
        // Optional parameters
        color: "skyblue",
        opacity: 0.1,
        loader: "dots",
      });
      this.locationList = [];
      this.pexipMgtConfig = [];
      this.pexipDeviceConfig = [];
      this.pexipDeviceConfigWithFilter = [];
      this.devices = [];
      this.staticConfiguration = false;
      try{
      await this.getLocationList();
      await this.getTenantDevices();
      await this.getPexipConfig();
      }
      finally{
      loader.hide();
      }
    },
    managementServerInfoSaved() {
      this.tenantSelected();
    },
    async deviceFilterSaved() {
      this.pexipMgtConfig = [];
      this.pexipDeviceConfig = [];
      this.pexipDeviceConfigWithFilter = [];
      await this.getPexipConfig();
    },
    filterDeviceFilters(event) {
      if (this.deviceFilterSearchString && this.deviceFilterSearchString.length >= 3) {
        this.pexipDeviceConfigWithFilter = this.pexipDeviceConfig.filter(d => d.filterName && d.filterName.toLowerCase().indexOf(this.deviceFilterSearchString.toLowerCase()) > -1);
      } else {
        this.pexipDeviceConfigWithFilter = this.pexipDeviceConfig;
      }
    },
    clearSearch() {
      this.pexipDeviceConfigWithFilter = this.pexipDeviceConfig;
      this.deviceFilterSearchString = "";
    },
    async getLocationList() {
      const claims = await this.$auth.getIdTokenClaims();
      const id_token = claims.__raw;
      // var url = config.API_GATEWAY + `tenants/${this.lastSelectedTenant}/locations/incomplete-taxonomy`;
      var url = config.API_GATEWAY + `/location/userLocations?tenantName=${this.lastSelectedTenant}`
      var locationRequest = new Request(url, {
        method: "GET",
        mode: "cors",
        cache: "default",
        withCredentials: true,
        headers: {
          Authorization: "Bearer " + id_token,
          "Content-Type": "application/json"
        }
      });
      try {
        var response = await fetch(locationRequest);
        if (response.status === 503) {
          return this.getLocationList();
        }
        var locationsList = await response.json();
        if (locationsList && locationsList.length > 0) {
          let locations = [];
          locationsList.forEach((l) => {
            if (l.units && l.units.length > 0) {
              let units = []
              l.units.forEach(unit => {
                if (unit && unit.areas && unit.areas.length > 0) {
                  let areas = [];
                  unit.areas.forEach((area) => {
                    areas.push({
                      aId: area.id,
                      name: area.name,
                      type: area.type
                    })
                  })
                  units.push({
                    uId: unit.id,
                    name: unit.name,
                    areas: areas
                  })
                }
              })
              locations.push({
                lId: l.locationId,
                name: l.name,
                units: units
              });
            }
          })
          this.locationList = locations;
        }
      } catch (error) {
        console.error(error);
      }
    },
    async getTenantDevices(nextRequest = "limit=500&offset=0") {
      const claims = await this.$auth.getIdTokenClaims();
      const id_token = claims.__raw;
      var url = config.OPERATIONS_SERVICE + `/tenants/${this.lastSelectedTenant}/devices?${nextRequest}`;
      var devicesRequest = new Request(url, {
        method: "GET",
        mode: "cors",
        cache: "default",
        withCredentials: true,
        headers: {
          Authorization: "Bearer " + id_token,
          "Content-Type": "application/json"
        }
      });
      try {
        var response = await fetch(devicesRequest);
        if (response.status === 503) {
          return this.getLocationList();
        }
        const devicesResponse = await response.json();
        if (devicesResponse) {
          this.devices = [...this.devices, ...devicesResponse.devices];

          if (devicesResponse.next) return await this.getTenantDevices(devicesResponse.next);
        }
      } catch (error) {
        console.error(error);
      }
    },
    async updatePexipConfig() {
      const claims = await this.$auth.getIdTokenClaims();
      const id_token = claims.__raw;
      var url = config.OPERATIONS_SERVICE + `/tenants/${this.lastSelectedTenant}/virtual-media-info/reset-cache`
      var pexipConfigRequest = new Request(url, {
        method: "PUT",
        mode: "cors",
        cache: "default",
        withCredentials: true,
        headers: {
          Authorization: "Bearer " + id_token,
          "Content-Type": "application/json"
        }
      });

      try {
        await fetch(pexipConfigRequest);
      } catch (error) {
        console.error(error);
      }
    },
    async getPexipConfig() {
      const claims = await this.$auth.getIdTokenClaims();
      const id_token = claims.__raw;
      var url = config.OPERATIONS_SERVICE + `/tenants/${this.lastSelectedTenant}/virtual-media-info`
      var pexipConfigRequest = new Request(url, {
        method: "GET",
        mode: "cors",
        cache: "default",
        withCredentials: true,
        headers: {
          Authorization: "Bearer " + id_token,
          "Content-Type": "application/json"
        }
      });

      try {
        var response = await fetch(pexipConfigRequest);
        if (response.status === 503) {
          return this.getPexipConfig();
        }
        var pexipConfiguration = await response.json();
        if (pexipConfiguration) {
          if (pexipConfiguration.management_servers && pexipConfiguration.management_servers.length > 0) {
            this.pexipMgtConfig = pexipConfiguration.management_servers;
          }
          if (pexipConfiguration.staticConfiguration) this.staticConfiguration = pexipConfiguration.staticConfiguration;

          this.getPexipDeviceConfig(pexipConfiguration);
          this.buildUIMappingForDeviceConfig();
        }
      } catch (error) {
        console.error(error);
      }
    },
    buildUIMappingForDeviceConfig() {
      if (this.pexipDeviceConfig && this.pexipDeviceConfig.length > 0) {
        this.pexipDeviceConfig.forEach(deviceFilter => {
          // console.log('buildUIMappingForDeviceConfig', deviceFilter);
          if (deviceFilter.pexipConfig && Array.isArray(deviceFilter.pexipConfig) && deviceFilter.pexipConfig.length > 0) {
            deviceFilter.pexipConfig.forEach(devicePexipConfig => {
              const managmentNodeUsedForDevice = this.pexipMgtConfig.find(m => m.key === devicePexipConfig.management_node);
              if (managmentNodeUsedForDevice) {
                if (!deviceFilter["configs"]) deviceFilter["configs"] = [];
                deviceFilter["configs"].push({
                  ip_cidr: devicePexipConfig.ip_cidr,
                  key: devicePexipConfig.management_node,
                  url: managmentNodeUsedForDevice.url,
                  deviceMediaNode: devicePexipConfig.deviceMediaNode,
                  dashboardMediaNode: devicePexipConfig.dashboardMediaNode,
                  mediaNode: devicePexipConfig.mediaNode,
                });
              }
            })
          } else if (deviceFilter.pexipConfig) {
            const managmentNodeUsedForDevice = this.pexipMgtConfig.find(m => m.key === deviceFilter.pexipConfig.management_node);
            if (managmentNodeUsedForDevice) {
              deviceFilter["config"] = {
                key: deviceFilter.pexipConfig.management_node,
                url: managmentNodeUsedForDevice.url,
                deviceMediaNode: deviceFilter.pexipConfig.deviceMediaNode,
                dashboardMediaNode: deviceFilter.pexipConfig.dashboardMediaNode,
              }
            }
          }
        })
      }

      this.pexipDeviceConfig.sort((a, b) => {
        return a.filterName.localeCompare(b.filterName);
      })

      this.pexipDeviceConfigWithFilter = this.pexipDeviceConfig;
    },
    findDeviceTypesInKey(keyFilter) {
      for (let i = 0; i < DEFAULT_DEVICE_TYPES_IN_PEXIP_CONFIG.length; i++) {
        if (keyFilter.includes(DEFAULT_DEVICE_TYPES_IN_PEXIP_CONFIG[i].id)) {
          return DEFAULT_DEVICE_TYPES_IN_PEXIP_CONFIG[i];
        }
      }
      return null;
    },
    editDeviceFilters(filterName) {
      // console.log("editDeviceFilters", filterName);
      if (filterName) {
        const devicePexipFilter = this.pexipDeviceConfig.find(d => d.filterKey === filterName);
        if (devicePexipFilter) {
          this.selectedDeviceFilter = filterName;
          this.$refs['addEditDeviceConfig'].showModal = true;
        }
      }
    },
    getPexipDeviceConfig(pexipConfiguration) {
      if (pexipConfiguration) {
        for (let [key, value] of Object.entries(pexipConfiguration)) {
          if (key && DEFAULT_PEXIP_ATTRIBUTES_TO_IGNORE.includes(key)) continue;

          key = key.replace("_filter", "");
          let otherIds = [];
          const includedDeviceType = this.findDeviceTypesInKey(key)
          if (includedDeviceType) {
            const remainingKey = key.replace(`_${includedDeviceType.id}`, "");
            if (!remainingKey) {
              this.pexipDeviceConfig.push({
                filterTemplate: "BY_MODEL",
                filterKey: key,
                deviceTypeId: remainingKey.id,
                model: remainingKey.name,
                pexipConfig: value,
                filterName: remainingKey.name
              });
            } else {
              otherIds = remainingKey.split("_");
            }
          } else {
            otherIds = key.split("_");
          }

          if (otherIds && otherIds.length > 0) {
            if (otherIds.length === 3) {
              const id1 = otherIds[0]
              const id2 = otherIds[1];
              const id3 = otherIds[2];
              if (id1 && id2 && id3) {
                if (id1.includes("cai:") || id2.includes("cai:") || id3.includes("cai:")) {

                } else {
                  const locationRoomInfo = this.locationList.find(l => l.lId === id1);
                  if (locationRoomInfo) {
                    const unitInfo = locationRoomInfo.units.find(u => u.uId === id2);
                    if (unitInfo) {
                      const areaInfo = unitInfo.areas.find(a => a.aId === id3);
                      if (areaInfo) {
                        let filterName = `${locationRoomInfo.name} / ${unitInfo.name} / ${areaInfo.name}`;
                        let filterTemplate = "BY_FACILITY";
                        if (includedDeviceType) {
                          filterName += ` / ${includedDeviceType.type}`
                          filterTemplate = "BY_FACILITY_MODEL";
                        }
                        this.pexipDeviceConfig.push({
                          filterTemplate: filterTemplate,
                          filterKey: key,
                          filterName: filterName,
                          locationId: id1,
                          unitId: id2,
                          areaId: id3,
                          deviceTypeId: includedDeviceType && includedDeviceType.id || undefined,
                          model: includedDeviceType && includedDeviceType.type || undefined,
                          pexipConfig: value,
                        })
                      }
                    }
                  }
                }
              }
            } else if (otherIds.length === 2) {
              const id1 = otherIds[0]
              const id2 = otherIds[2];
              if (id1 && id2) {
                if (id1.includes("cai:") || id2.includes("cai:")) {

                } else {
                  const locationRoomInfo = this.locationList.find(l => l.lId === id1);
                  if (locationRoomInfo) {
                    const unitInfo = locationRoomInfo.units.find(u => u.uId === id2);
                    if (unitInfo) {
                      let filterName = `${locationRoomInfo.name} / ${unitInfo.name}`;
                      let filterTemplate = "BY_FACILITY";
                      if (includedDeviceType) {
                        filterName += ` / ${includedDeviceType.name}`;
                        filterTemplate = "BY_FACILITY_MODEL";
                      }
                      this.pexipDeviceConfig.push({
                        filterTemplate: filterTemplate,
                        filterKey: key,
                        filterName: filterName,
                        locationId: id1,
                        unitId: id2,
                        deviceTypeId: includedDeviceType && includedDeviceType.id || undefined,
                        model: includedDeviceType && includedDeviceType.type || undefined,
                        pexipConfig: value,
                      })
                    }
                  }
                }
              }
            } else if (otherIds.length === 1) {
              const id1 = otherIds[0];
              if (id1 && id1.includes("cai:")) {
                let filterName = `${id1} -> Unassigned Sensor (Room info does not match)`
                const deviceInfo = this.devices.find(l => l.deviceId === id1);
                if (deviceInfo) {
                  const locationInfo = this.locationList.find(l => l.lId === deviceInfo.location);
                  if (locationInfo) {
                    const unitInfo = locationInfo.units.find(u => u.uId === deviceInfo.unit);
                    if (unitInfo) {
                      const areaInfo = unitInfo.areas.find(a => a.aId === deviceInfo.area);
                      if (areaInfo) {
                        filterName = `${id1} -> ${locationInfo.name} / ${unitInfo.name} / ${areaInfo.name}`;
                      }
                    }
                  }
                }
                this.pexipDeviceConfig.push({
                  filterTemplate: "BY_DEVICE_ID",
                  filterKey: key,
                  filterName: filterName,
                  deviceId: id1,
                  pexipConfig: value,
                })
              } else {
                const locationRoomInfo = this.locationList.find(l => l.lId === id1);
                if (locationRoomInfo) {
                  let filterName = `${locationRoomInfo.name}`;
                  let filterTemplate = "BY_FACILITY";
                  if (includedDeviceType) {
                    filterName += ` / ${includedDeviceType.type}`;
                    filterTemplate = "BY_FACILITY_MODEL";
                  }
                  this.pexipDeviceConfig.push({
                    filterTemplate: filterTemplate,
                    filterKey: key,
                    filterName: filterName,
                    locationId: id1,
                    deviceTypeId: includedDeviceType && includedDeviceType.id || undefined,
                    model: includedDeviceType && includedDeviceType.type || undefined,
                    pexipConfig: value,
                  })
                } else {
                  let filterName = `${id1} -> No mapping found`;
                  let filterTemplate = "BY_FACILITY";
                  if (includedDeviceType) {
                    filterName += ` / ${includedDeviceType.type}`;
                    filterTemplate = "BY_FACILITY_MODEL";
                  }
                  this.pexipDeviceConfig.push({
                    filterTemplate: filterTemplate,
                    filterKey: key,
                    filterName: filterName,
                    locationId: id1,
                    deviceTypeId: includedDeviceType && includedDeviceType.id || undefined,
                    model: includedDeviceType && includedDeviceType.type || undefined,
                    pexipConfig: value,
                  })
                }
              }
            }
          }
        }
      }
    }
  }
}
</script>

<!-- Header Styles -->
<style lang="scss" scoped>
.page-header {
  &__flex {
    display: flex;
    align-items: center;
    justify-content: space-between;
  }

  &__statistics {
    display: flex;
    align-items: center;
    justify-content: space-between;
  }

  &__statistics-item {
    font-size: .7em;
    display: flex;
    flex-direction: column;
  }

  .filterWrapper {
    background: #575757;
    display: inline-flex;
    padding: 0px 15px;
    font-size: 15px;
    min-width: 360px;
    max-width: 360px;
    border-radius: 5px;
    margin-left: 10px;
    align-items: center;
    text-overflow: ellipsis;

    .filterText {
      color: #fff;
      opacity: 1;
      padding-right: 5px;
    }

    .dropdown .dropdown-content {
      max-width: 228px;
      min-width: 228px;
      margin-top: 5px;
    }

    .dropdown:before {
      content: "";
      border: solid #8e8e8e;
      border-width: 0 1px 1px 0;
      display: inline-block;
      padding: 3px;
      transform: rotate(45deg);
      -webkit-transform: rotate(45deg);
      position: absolute;
      right: 0px;
      top: 15px;
    }
  }

  .filterWrapper .dropdown .dropdown-content {
    max-width: 228px;
    min-width: 228px;
    margin-top: 5px;
  }

  body .dropdown.tenantsList .dropdown-input {
    text-overflow: ellipsis;
    white-space: nowrap;
    width: 90%;
    overflow: hidden;
    min-width: auto;
  }
}

.alert {
  color: #d43d3d;
}

.row-light {
  background-color: #f2f2f2;
  border-top: #2e2e2e 1px solid;
  border-bottom: #2e2e2e 1px solid;
}

</style>